import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, ExternalLink } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { SocialLinks } from "./SocialLinks";

export const PHONE_DISPLAY = "+1 581-202-1112";
export const PHONE_TEL = "+15812021112";
export const ADDRESS_STREET = "2828, boulevard Laurier, bureau 700";
export const ADDRESS_CITY = "Québec (Québec) G1V 0B9";
export const ADDRESS_COUNTRY = "Canada";
export const MAPS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=" +
  encodeURIComponent("2828 Boulevard Laurier, Québec, QC G1V 0B9, Canada");

export function Footer() {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#E5E0D8] bg-[#FDFBF7] pt-12 pb-8 mt-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid gap-10 md:grid-cols-3">
        {/* Brand + tagline */}
        <div>
          <div className="font-display font-black text-2xl text-[#2B2B2B]">Vytali</div>
          <p className="mt-3 text-sm text-[#5C5C5C] leading-relaxed max-w-xs">
            {t("footer.tagline")}
          </p>
          <SocialLinks variant="footer" className="mt-5" />
        </div>

        {/* Corporate contact (Vytali HQ, NOT a partner restaurant) */}
        <div data-testid="footer-contact-block">
          <div className="text-xs font-mono uppercase tracking-widest text-[#9C9C9C] mb-3">
            Coordonnées corporatives
          </div>
          <a
            data-testid="footer-phone-link"
            href={`tel:${PHONE_TEL}`}
            className="group inline-flex items-center gap-2 text-[#2B2B2B] hover:text-[#E63946] font-medium transition-colors"
          >
            <Phone className="w-4 h-4" strokeWidth={2.2} />
            <span className="tabular-nums">{PHONE_DISPLAY}</span>
          </a>
          <address className="not-italic mt-3 text-sm text-[#5C5C5C] leading-relaxed">
            <div className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-[3px] shrink-0 text-[#9C9C9C]" strokeWidth={2.2} />
              <span>
                {ADDRESS_STREET}
                <br />
                {ADDRESS_CITY}
                <br />
                {ADDRESS_COUNTRY}
              </span>
            </div>
          </address>
          <a
            data-testid="footer-directions-link"
            href={MAPS_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-[#E63946] hover:underline"
          >
            Obtenir l'itinéraire
            <ExternalLink className="w-3.5 h-3.5" strokeWidth={2.4} />
          </a>
          <p className="mt-3 text-[11px] font-mono text-[#9C9C9C] leading-snug max-w-xs">
            Siège social de Vytali — ce n'est pas une adresse de restaurant partenaire.
          </p>
        </div>

        {/* Copyright + quick links */}
        <div className="text-sm text-[#5C5C5C] md:text-right space-y-2">
          <div>
            <Link
              data-testid="footer-contact-link"
              to="/contact"
              className="text-[#2B2B2B] font-medium hover:text-[#E63946] transition-colors"
            >
              Contact
            </Link>
          </div>
          <div className="font-mono">© 2026 Vytali</div>
          <div className="text-xs font-mono text-[#9C9C9C]">
            vytali.ca · Québec, Canada
          </div>
        </div>
      </div>
    </footer>
  );
}
